(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["advantage-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Advantage section
(function () {
jQuery(document).ready(function () {
$('.advantage__slider').owlCarousel({
items: 1,
center: true,
loop: true,
stagePadding: 50,
autoWidth: true,
margin: 14,
nav: true,
navText: ["<span class='slider-arrow prev'></span>", "<span class='slider-arrow next'></span>"],
responsive: {
1200: {
margin: 30.25
}
}
});
});
})(jQuery); //END Advantage section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Buy section
(function () {
jQuery(document).ready(function () {
$(".buy__slider").owlCarousel({
loop: true,
items: 1,
nav: true,
dots: false,
margin: 25,
navText: ["<span class='slider-arrow prev'></span>", "<span class='slider-arrow next'></span>"]
});
var buySelectItem = $('.buy__select-item');
buySelectItem.eq(0).find('.buy__select-body').css('display', 'block');
buySelectItem.click(function () {
if ($(this).hasClass('is-selected')) {
return;
} else {
buySelectItem.each(function () {
if ($(this).hasClass('is-selected')) {
$(this).find('.buy__select-body').slideUp();
}

$(this).removeClass('is-selected');
});
$(this).addClass('is-selected');
$(this).find('.buy__select-body').slideDown();
}
});
});
})(jQuery); //END Buy section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Gallery
(function () {
jQuery(document).ready(function () {
function initGallerySlider() {
var checkWidth = $(window).width();
var gallerySlider = $(".gallery__slider");

if (checkWidth > 1023.8) {
if (typeof gallerySlider.data('owl.carousel') != 'undefined') {
gallerySlider.each(function () {
$(this).data('owl.carousel').destroy();
});
}

gallerySlider.each(function () {
$(this).removeClass('owl-carousel');
});
} else if (checkWidth < 1023.8) {
gallerySlider.addClass('owl-carousel');
gallerySlider.owlCarousel({
margin: 50,
items: 1,
loop: true,
dots: false,
nav: true,
navText: ["<span class='slider-arrow prev'></span>", "<span class='slider-arrow next'></span>"],
responsive: {
768: {
items: 2
}
}
});
}
}

initGallerySlider();
$(window).resize(initGallerySlider);
});
})(jQuery); //END Gallery

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Icons section
(function () {
jQuery(document).ready(function () {
function iconsSlider() {
var checkWidth = $(window).width();
var iconsItems = $(".icons__slider");

if (checkWidth > 767.8) {
if (typeof iconsItems.data('owl.carousel') != 'undefined') {
iconsItems.data('owl.carousel').destroy();
}

iconsItems.removeClass('owl-carousel');
} else if (checkWidth < 767.8) {
iconsItems.addClass('owl-carousel');
iconsItems.owlCarousel({
margin: 50,
items: 1.5,
loop: true,
dots: false,
nav: true,
navText: ['<svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M27.4995 13.5L0.999759 13.5M0.999759 13.5L12.9998 25.5M0.999759 13.5L12.9998 1.5" stroke="#1A1A1A" stroke-width="2" stroke-linejoin="bevel"/>\n' + '</svg>\n', '']
});
}
}

iconsSlider();
$(window).resize(iconsSlider);
});
})(jQuery); //END Icons section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Press
(function () {
jQuery(document).ready(function () {
$('.press__slider').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: false,
asNavFor: '.press__nav' // swipeToSlide: false,
// touchMove: false,
// draggable: false

});
$('.press__nav').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.press__slider',
dots: false,
arrows: false,
focusOnSelect: true,
infinite: true,
responsive: [{
breakpoint: 767,
settings: {
slidesToShow: 3
}
}]
});
});
})(jQuery); //END Press

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-section"] && !window.DesignMode) return;
  try {
    
"use strict";

// Quotes
(function () {
jQuery(document).ready(function () {
$('.quotes__slider').owlCarousel({
items: 1,
dots: false,
nav: true,
loop: true,
autoHeight: true,
navText: ["<span class='slider-arrow prev'></span>", "<span class='slider-arrow next'></span>"],
responsive: {
767.8: {
autoHeight: false
}
}
});
});
})(jQuery); //END Quotes

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !window.DesignMode) return;
  try {
    
"use strict";

(function () {
jQuery(document).ready(function () {
$('.reviews-slider__slider').owlCarousel({
items: 1,
dots: false,
nav: false,
autoplay: true,
autoplayTimeout: 6000,
loop: true,
navText: ["<span class='slider-arrow prev'></span>", "<span class='slider-arrow next'></span>"],
responsive: {
1200: {
autoplay: false,
nav: true
}
}
});
});
})(jQuery);

  } catch(e) { console.error(e); }
})();

})();
